import { useTheme } from '../../../../../../../../components/CiscoUi';
import { determineEmbeddedAppIframeUrl } from '../utils/utils';
import styles from './index.module.css';

export type EmbeddAppProps = {
  embeddedAppUrl?: string;
  embeddedAppStatus: EmbeddedAppStates;
};

export const EmbeddedApp = ({
  embeddedAppUrl,
  embeddedAppStatus,
}: EmbeddAppProps) => {
  const [theme] = useTheme();

  if (embeddedAppStatus !== 'READY') return <></>;

  const embeddedAppIframeUrl = determineEmbeddedAppIframeUrl({
    embeddedAppUrl,
    theme,
  });

  return (
    <div className={styles.root}>
      <iframe
        title="Launch Panel"
        src={embeddedAppIframeUrl}
        loading="lazy"
        sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-same-origin"
        allow="geolocation 'self'; camera 'none'; microphone 'none'; usb 'none'; payment 'none'; screen-wake-lock 'none'"
        referrerPolicy="same-origin"
      ></iframe>
    </div>
  );
};
